import { Outlet, RouteObject } from "react-router";
import Sluterklaering from "@/routes/sluterklaering/Sluterklaering";
import IntroSluterklaering from "@/routes/sluterklaering/IntroSluterklaering";
import KlientkontoerklaeringTilsvar from "@/components/klientkontoerklaering/KlientkontoerklaeringTilsvar";
import KlientkontoerklaeringIntetTilsvar from "@/components/klientkontoerklaering/KlientkontoerklaeringIntetTilsvar";
import { klientkontoerklaeringIdLoader } from "@/routes/klientkontoerklaering/KlientkontoerklaeringById";
import PageError from "@/routes/PageError";
import { ROUTES } from "@/constants/routes";

export const sluterklaeringRoutes: RouteObject[] = [
  {
    path: "/sluterklaering",
    element: <Sluterklaering />,
    children: [
      {
        path: "/sluterklaering/:id",
        element: <Outlet />,
        loader: klientkontoerklaeringIdLoader,
        id: ROUTES.sluterklaering.id,
        children: [
          {
            path: "/sluterklaering/:id",
            element: <IntroSluterklaering />,
          },
          {
            path: "/sluterklaering/:id/tilsvar",
            element: (
              <KlientkontoerklaeringTilsvar
                loaderRouteId={ROUTES.sluterklaering.id}
                formularType="Formular1"
              />
            ),
            id: ROUTES.sluterklaeringTilsvar.id,
          },
          {
            path: "/sluterklaering/:id/intet-tilsvar",
            element: (
              <KlientkontoerklaeringIntetTilsvar
                loaderRouteId={ROUTES.sluterklaering.id}
              />
            ),
            id: ROUTES.sluterklaeringIntetTilsvar.id,
            errorElement: <PageError msg="Erklæring findes ikke" />,
          },
        ],
      },
    ],
  },
];
